<template>
    <div v-if="dataSource" class="p-relative">

        <Toolbar :isList="true" :hideCreateButton="hideCreate" :menu="menu" v-on:toolbar-button-click="onToolbarClick">

            <div class="top-btns-bar-right-section">

                <v-text-field
                    v-model="search"
                    append-icon="fas fa-search"
                    label="Что ищем? Например: краткое содержание"
                    hide-details
                    class="search-in-tooltip"
                    solo
                    flat
                    clearable
                ></v-text-field>
            </div>

        </Toolbar>

        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="collection"
            v-bind:substatus.sync="status"
        />

        <component :is="collection" :search="search" :status="status" ref="childComponent"/>
        
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import Axios from 'axios';
import { httpAPI } from "@/api/httpAPI";
import Toolbar from '@/components/Toolbar.vue';
import FilterPanel from '@/components/FilterPanel.vue';
import AllUsers from './lists/AllUsers.vue';
import ConnectedUsers from './lists/ConnectedUsers.vue';
import LockedUsers from './lists/LockedUsers.vue';
import WithoutLoginUsers from './lists/WithoutLoginUsers.vue';
import ByLevelUsers from './lists/ByLevelUsers.vue';

export default {
    name: "Users",
    components: {
        Toolbar,
        FilterPanel,
        AllUsers,
        ConnectedUsers,
        LockedUsers,
        WithoutLoginUsers,
        ByLevelUsers
    },
    data() {
        return {
            cancellationTokenSorce: null,
            dataSource: null,
            filterDataSource: null,
            menu: []
            //refreshConnectedUserInterval: null
        }
    },
    computed: {
        ...mapGetters('auth', ['getUserInfo']),
        collection: {
            get: function() {
                return this.$store.getters['users/getCollection']
            },
            set: function(newValue) {
                this.$store.commit('users/SET_COLLECTION', newValue);
            }
        },
        status: {
            get: function() {
                return this.$store.getters['users/getStatus'];
            },
            set: function(newValue) {
                if(newValue) {
                    this.$store.commit('users/PUSH_STATUS', { collection: this.collection, value: newValue } );

                    if (typeof this.$refs.childComponent?.resetPage === "function") { 
                        this.$refs.childComponent.resetPage();
                    }
                }
            }
        },
        search: {
            get: function() {
                return this.$store.getters['users/getSearch']
            },
            set: _.debounce(function(v) {
                this.$store.commit('users/PUSH_SEARCH', { collection: this.collection, value: v } );

                if (typeof this.$refs.childComponent?.resetPage === "function") { 
                    this.$refs.childComponent.resetPage();
                }
            }, 500)
        },
        hideCreate() {
            return this.getUserInfo.levelAccess < 50;
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        async onToolbarClick (event, btn) {
            switch(btn.Action)
            {
                case 'Refresh':
                    //await this.loadFilters();
                    await this.$refs.childComponent.getData(true);
                    break;

                default:
                    await this.$refs.childComponent.onToolbarClick(event, btn);
                    break;        
            }
            
        },
        async loadCollectionData(type) {
            let response = await httpAPI({
                url: `api/ems/collection?type=`+ (type ? type: this.collection),
                method: 'GET'
            });
            if (response) {
                this.dataSource = response.data.payload;
            }
            /*if (this.collection == 'ByLevelUsers' && this.status != 'InnerUsers' )
                this.menu = this.dataSource.Data.Menu.filter(item=>item.Action != "AddInnerEmployee");
            else */
                this.menu = this.dataSource.Data.Menu;
        },
        async loadFilters() {
            //let userInfo = this.$store.getters['auth/getUserInfo'];

            let filterResponse = await httpAPI({
                url: `api/ems/filter?collection=Users`,
                method: 'GET',
                cancelToken: this.cancellationTokenSorce.token,
            });
            this.filterDataSource = filterResponse?.data.payload;
        }
    },
    watch: {
        collection()
        {
            this.loadCollectionData();
        }
    },
    mounted() {
        this.$eventBus.$on('update-data-table', async () => {
            await this.$refs.childComponent.getData(true);
        });
    },
    beforeDestroy() {
        this.$eventBus.$off('update-data-table');
    },
    async created() {
        this.setOverlayVisible({ visible: true });

        if (this.cancellationTokenSorce)
            this.cancellationTokenSorce.cancel('Обновление предыдущей категории прервано из-за выбора новой категории');

        this.cancellationTokenSorce = Axios.CancelToken.source();
        
        await this.loadFilters();
        await this.loadCollectionData();

        this.setOverlayVisible({ visible: false });
    },
}
</script>